import React from 'react';
import T from 'prop-types';
import { Pressable } from 'react-native';

import iconDictionary from '../../../../utils/iconDictionary';
import { ConditionalRender, H5, P3 } from '../../../base_ui';
import ErrorValue from './ErrorValue';
import RowButtonValue from './RowButtonValue';
import {
  ArrowWrapper,
  DefaultRow,
  DefaultRowContainer,
  ValueIconWrapper,
} from './styledComponents';

const ArrowIcon = iconDictionary('arrowRightM');

const RowButton = ({
  handlePress,
  label,
  labelSubText = '',
  noPaymentSchedule = false,
  noPaymentSource = false,
  noValueErrorLabel,
  value,
}) => (
  <Pressable onPress={handlePress}>
    <DefaultRow $hasLabelSubText={!!labelSubText}>
      <DefaultRowContainer>
        <H5>{label}</H5>
        <ValueIconWrapper>
          <ConditionalRender
            Component={RowButtonValue}
            FallbackComponent={ErrorValue}
            propsToPassDown={{ noValueErrorLabel, value }}
            shouldRender={!noPaymentSource && !noPaymentSchedule}
          />
          <ArrowWrapper>{ArrowIcon}</ArrowWrapper>
        </ValueIconWrapper>
      </DefaultRowContainer>
      <ConditionalRender
        Component={<P3>{labelSubText}</P3>}
        shouldRender={!!labelSubText}
      />
    </DefaultRow>
  </Pressable>
);

RowButton.propTypes = {
  handlePress: T.func.isRequired,
  label: T.string.isRequired,
  labelSubText: T.string,
  noPaymentSchedule: T.bool,
  noPaymentSource: T.bool,
  noValueErrorLabel: T.string,
  value: T.string.isRequired,
};

export default RowButton;
